import React, { Fragment } from 'react';

import {
    Heading,
    Container,
    Row,
    Col,
    Text,
    className,
} from 'aplazame-design-system';

import PricingTable from '../PricingTable';

import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';
import sectionStyle from 'aplazame-design-system/src/scss/section.module.scss';
import style from './style.module.scss';

export default function PricingSection({
    title,
    titleTag,
    text,
    colorScheme,
    pricingTable,
    button,
    hideOnMobile,
    id,
}) {
    colorScheme = colorScheme?.toLowerCase();
    const hasColorScheme = colorScheme !== 'none';
    const isSinglePricing =
        pricingTable.rows.length && pricingTable.rows[0].length === 1;

    return (
        <section
            aria-labelledby={id}
            {...className(
                [
                    colorStyle[`with-bg--${colorScheme}`],
                    sectionStyle['with-bg'],
                    sectionStyle['with-bg--none'],
                    hasColorScheme ? 'mt-10 mb-10 mt-lg-20 mb-lg-20' : '',
                    hideOnMobile ? 'd-none d-lg-block' : '',
                ].join(' ')
            )}
        >
            {hasColorScheme ? (
                <div className={`${sectionStyle.bg} ${colorStyle.bg}`} />
            ) : null}
            <Container pt={{ xs: 15, lg: 20 }} pb={{ xs: 15, lg: 20 }}>
                <Row className="text-center">
                    <Col col={{ lg: 10 }} offset={{ lg: 1 }}>
                        <Heading
                            id={id}
                            tag={titleTag}
                            className={`${style.heading} mb-${text ? 6 : 15}`}
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                        >
                            {title}
                        </Heading>
                    </Col>
                    {text ? (
                        <Col col={{ lg: 8 }} offset={{ lg: 2 }}>
                            <Text
                                tag="div"
                                className={`h3 mb-10 ${style.text}`}
                                data-sal="slide-up"
                                data-sal-easing="ease-out-quart"
                            >
                                {text}
                            </Text>
                        </Col>
                    ) : null}
                </Row>
                <Row>
                    <Col
                        col={
                            isSinglePricing
                                ? {
                                    lg: 10,
                                    xl: 8,
                                }
                                : null
                        }
                        offset={
                            isSinglePricing
                                ? {
                                    lg: 1,
                                    xl: 2,
                                }
                                : null
                        }
                    >
                        <PricingTable
                            button={button}
                            pricingTable={pricingTable}
                            wrapperClassName={
                                !isSinglePricing
                                    ? `d-none d-lg-block ${style.table}`
                                    : ''
                            }
                            data-sal="slide-up"
                            data-sal-easing="ease-out-quart"
                            headBackground={!hasColorScheme}
                        />
                        {!hideOnMobile && !isSinglePricing ? (
                            <div {...className('d-lg-none')}>
                                {pricingTable.headers.map((header, i) => {
                                    if (!i) {
                                        return null;
                                    }

                                    return (
                                        <Fragment key={i}>
                                            <Heading
                                                tag="h5"
                                                className={`h4 mb-5 mt-${i === 1 ? 5 : 10
                                                    } font-weight-bold ${style.subTitle
                                                    }`}
                                                data-sal="slide-up"
                                                data-sal-easing="ease-out-quart"
                                            >
                                                {header}
                                            </Heading>
                                            <PricingTable
                                                key={i}
                                                button={button}
                                                wrapperClassName={
                                                    !isSinglePricing
                                                        ? `${style.table}`
                                                        : ''
                                                }
                                                slug={
                                                    pricingTable.slugs &&
                                                        pricingTable.slugs[i - 1]
                                                        ? pricingTable.slugs[
                                                        i - 1
                                                        ]
                                                        : null
                                                }
                                                pricingTable={{
                                                    ...pricingTable,
                                                    headers: [],
                                                    rows: pricingTable.rows.map(
                                                        (row) => [row[i - 1]]
                                                    ),
                                                }}
                                                data-sal="slide-up"
                                                data-sal-easing="ease-out-quart"
                                                headBackground={!hasColorScheme}
                                            />
                                        </Fragment>
                                    );
                                })}
                            </div>
                        ) : null}
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
